var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 8C10.3236 8 11.6667 6.65685 11.6667 5C11.6667 3.34315 10.3236 2 8.66675 2C7.00989 2 5.66675 3.34315 5.66675 5C5.66675 6.65685 7.00989 8 8.66675 8ZM10.6667 5C10.6667 6.10457 9.77132 7 8.66675 7C7.56218 7 6.66675 6.10457 6.66675 5C6.66675 3.89543 7.56218 3 8.66675 3C9.77132 3 10.6667 3.89543 10.6667 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13C14.6667 14 13.6667 14 13.6667 14H3.66675C3.66675 14 2.66675 14 2.66675 13C2.66675 12 3.66675 9 8.66675 9C13.6667 9 14.6667 12 14.6667 13ZM13.6667 12.9965C13.6653 12.7497 13.513 12.0104 12.8346 11.3321C12.1824 10.6798 10.9558 10 8.66674 10C6.37763 10 5.1511 10.6798 4.49884 11.3321C3.8205 12.0104 3.66817 12.7497 3.66675 12.9965H13.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.11517f89803a2af8ac1128c6febd83ab.svg";
export { ForwardRef as ReactComponent };